import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import Router from './components/Utilities/Router/Router';
import { history } from './components/Utilities/Router/History';
import ErrorBoundary from './components/Global/ErrorBoundary/ErrorBoundary';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <Router history={history}>
      <App />
    </Router>
  </ErrorBoundary>
);
